$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".ess-play-button", function (e) {
     var video = jQuery(this).parents('.ess-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.ess-video-wrapper').removeClass('ess-active');
     jQuery(this).removeClass('ess-active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.ess-video-wrapper').addClass('ess-active');
     jQuery(this).addClass('ess-active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".ess-question", function (e) {
  if (jQuery(this).hasClass("ess-active")) {
    jQuery(this).toggleClass('ess-active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.ess-question').removeClass('ess-active');
    jQuery('.ess-question').next().slideUp();
    jQuery(this).toggleClass('ess-active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.ess-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.ess-product-column2').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".ess-mobile-menu-button", function (e) {
    $('.ess-drawer-menu').addClass('ess-active');
    $('.ess-drawer-menu-bg').show();
    $('body').addClass('ess-overflow-hidden');
});
$(document).on("click", ".ess-mobile-menu-close", function (e) {
    $('.ess-drawer-menu').removeClass('ess-active');
    $('.ess-drawer-menu-bg').hide();
    $('body').removeClass('ess-overflow-hidden');
});

$(document).on("click", ".ess-drawer-menu-bg", function (e) {
    $('.ess-drawer-menu').removeClass('ess-active');
    $('.ess-drawer-menu-bg').hide();
    $('body').removeClass('ess-overflow-hidden');
});




$(document).on("click", ".ess-element-variant", function(e) {
    e.preventDefault();
$(this).parents('.ess-product').find('.ess-element-variant').removeClass('ess-active');
$(this).addClass('ess-active');
var variant_id = $(this).attr('variant_id');
var selling_plan = $(this).attr('selling_plan');
var sub_tab = $('.ess-element-sub-option.ess-active').attr('sub_tab');
$(this).parents('.ess-product').find('.ess-variant-trigger').hide();
$(this).parents('.ess-product').find('.ess-variant-trigger[variant_id="'+variant_id+'"]').show();
$(this).parents('.ess-product').find('.ess-checkout-button').attr('variant_id',variant_id);
if(sub_tab=='1'){
$(this).parents('.ess-product').find('.ess-checkout-button').attr('selling_plan',selling_plan);
} else {
$(this).parents('.ess-product').find('.ess-checkout-button').removeAttr('selling_plan');
}
});



$(document).on('click', '.ess-element-sub-option:not(.ess-active)', function (e) {
    e.preventDefault();
$(this).parents('.ess-product').find('.ess-element-sub-option').removeClass('ess-active');
$(this).addClass('ess-active');
var sub_tab = $(this).attr('sub_tab');
var selling_plan = $('.ess-element-variant.ess-active').attr('selling_plan');
$(this).parents('.ess-product').find('.ess-sub-trigger').hide();
$(this).parents('.ess-product').find('.ess-sub-trigger[sub_tab="'+sub_tab+'"]').show();
if(sub_tab=='1'){
$(this).parents('.ess-product').find('.ess-checkout-button').attr('selling_plan',selling_plan);
} else {
$(this).parents('.ess-product').find('.ess-checkout-button').removeAttr('selling_plan');
}
});



$(document).on('click', '.ess-element-sub-option.ess-active', function (e) {
    e.preventDefault();
    $('.ess-element-sub-option:not(.ess-active)').trigger('click');
});







$(document).on("click", ".ess-cart-button", function (e) {
      $('#cart-drawer').addClass('open');
      $('.custom_overlay2').addClass('active');
});
$(document).on("click", ".ess-mobile-cart-close, .ess-drawer-cart-bg, a[href='#close_cart']", function (e) {
  e.preventDefault();
    $('.ess-cart-drawer').removeClass('ess-active');
    $('.ess-drawer-cart-bg').hide();
    $('body').removeClass('ess-overflow-hidden');
});






function essCheckViewport() {
  $('.ess-pdp-weeks-list1-item').each(function () {
    var $this = $(this);

    // Skip if already activated
    if ($this.hasClass('ess-active')) {
      return;
    }

    var rect = this.getBoundingClientRect();
    var elementCenter = rect.top + (rect.height / 2);
    var viewportCenter = window.innerHeight / 2;

    // Trigger when element center reaches viewport center
    if (Math.abs(elementCenter - viewportCenter) <= 50) {
      $this.addClass('ess-active');
    }
  });
}

$(window).on('scroll', essCheckViewport);
function essAnimateNumbers() {
  $('.ess-pdp-number-list1-item .ess-svg').each(function () {
    var $this = $(this);

    // Store original number and immediately show 0%
    if (!$this.data('target-number')) {
      var originalText = $.trim($this.text());
      var target = parseInt(originalText.replace('%', ''), 10);

      if (isNaN(target)) {
        return;
      }

      $this.data('target-number', target);
      $this.text('0%');
    }

    // Skip if already animated
    if ($this.hasClass('ess-number-animated')) {
      return;
    }

    var rect = this.getBoundingClientRect();
    var elementCenter = rect.top + (rect.height / 2);
    var viewportCenter = window.innerHeight / 2;

    // Trigger when element center reaches viewport center
    if (Math.abs(elementCenter - viewportCenter) <= 50) {
      $this.addClass('ess-number-animated');

      var target = $this.data('target-number');

      $({ count: 0 }).animate(
        { count: target },
        {
          duration: 1500,
          easing: 'swing',
          step: function (now) {
            $this.text(Math.floor(now) + '%');
          },
          complete: function () {
            $this.text(target + '%');
          }
        }
      );
    }
  });
}

$(document).ready(function () {
  essAnimateNumbers();
});

$(window).on('scroll', essAnimateNumbers);